import { IntersectionAreas } from '@rta/rta-blueprint-library';

export type DevShowIntersectionAreasProps = {
	areas: IntersectionAreas
};

export const DevShowIntersectionAreas = (props): React.ReactElement => {
	const { areas } = props;
	const areaBoxes: React.ReactElement[] = [];

	areas.forEach((area, i) => {
		if (area.size.height === 0) {
			console.warn('overlap height is 0', area);
			return;
		}

		const overlapRectBaseProps = {
			x: area.origin.x - (area.size.width / 2) + 0.125,
			y: area.origin.y - (area.size.height / 2) + 0.125,
			width: Math.max(area.size.width - 0.25, 0),
			height: Math.max(area.size.height - 0.25, 0),
			opacity: '0.5',
			pointerEvents: 'none'
		};

		if (area.axis.z === 0) {
			// console.log('overlap', overlap);
			areaBoxes.push(<rect key={i} {...overlapRectBaseProps}
				fill="lightblue"
			/>);
		// deepcode ignore DuplicateIfBody: leave to add more conditions for debugging
		} else if (area.axis.z === 90) {
			areaBoxes.push(<rect key={i} {...overlapRectBaseProps}
				fill="lightblue"
			/>);
		}
	})

	return <g>{areaBoxes}</g>;
};
